module.exports = __webpack_public_path__ + "img/bottom_size.ade640bb.png";